import { render, staticRenderFns } from "./SelfRatingTab.vue?vue&type=template&id=12b4f914&scoped=true"
import script from "./SelfRatingTab.vue?vue&type=script&lang=js"
export * from "./SelfRatingTab.vue?vue&type=script&lang=js"
import style0 from "./SelfRatingTab.vue?vue&type=style&index=0&id=12b4f914&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4f914",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b4f914')) {
      api.createRecord('12b4f914', component.options)
    } else {
      api.reload('12b4f914', component.options)
    }
    module.hot.accept("./SelfRatingTab.vue?vue&type=template&id=12b4f914&scoped=true", function () {
      api.rerender('12b4f914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/rating/partials/tabs/SelfRatingTab.vue"
export default component.exports